<div class="sidebar" [class.collapsed]="isCollapsed" [class.open]="isMobileOpen">

  <!-- Desktop collapse toggle -->
  <button
    class="toggle-btn"
    [style.left]="toggleBtnLeft"
    (click)="toggleCollapse()"
    [title]="isCollapsed ? 'Open sidebar' : 'Close sidebar'"
  >
    <i [class]="isCollapsed ? 'fas fa-chevron-right' : 'fas fa-chevron-left'"></i>
  </button>

  <!-- Sidebar Header -->
  <div class="sidebar-header">
    <div class="logo">
      <img src="Indowest_logo.png" alt="Logo"
           onerror="this.style.display='none';this.nextElementSibling.style.display='flex'"
           style="width:100%;height:100%;object-fit:contain" />
      <span style="display:none;width:100%;height:100%;align-items:center;justify-content:center;font-size:1.4rem;font-weight:700;color:#0ea4f4">SE</span>
    </div>
    <ng-container *ngIf="!isCollapsed">
      <h3>School Portal</h3>
      <p *ngIf="schoolName">{{ schoolName }}</p>
      <p *ngIf="!schoolName">Dashboard</p>

      <div class="academic-year" *ngIf="currentAcademicYear">
        <i class="fas fa-calendar-alt"></i>
        <span>{{ currentAcademicYear }}</span>
      </div>

      <div class="academic-year loading" *ngIf="isLoadingAcademicYear">
        <i class="fas fa-spinner fa-spin"></i>
        <span>Loading...</span>
      </div>
    </ng-container>
  </div>

  <!-- Nav -->
  <nav class="sidebar-nav">

    <!-- Common Items -->
    <ng-container *ngFor="let item of commonMenuItems">
      <a
        *ngIf="item.route !== '/change-password'"
        [routerLink]="item.route"
        routerLinkActive="active"
        class="nav-item"
        [title]="item.label"
        (click)="closeMobileSidebar()"
      >
        <i [class]="item.icon"></i>
        <span *ngIf="!isCollapsed">{{ item.label }}</span>
      </a>
    </ng-container>

    <!-- Admin Submenu -->
    <ng-container *ngIf="isAdmin">
      <div
        class="nav-item nav-group-header"
        [class.open]="isAdminMenuOpen"
        (click)="toggleAdminMenu()"
        [title]="isCollapsed ? 'Admin' : ''"
      >
        <i class="fas fa-shield-alt"></i>
        <span *ngIf="!isCollapsed">Admin</span>
        <i *ngIf="!isCollapsed" class="fas fa-chevron-down submenu-arrow"></i>
      </div>

      <div class="submenu" [class.open]="isAdminMenuOpen && !isCollapsed">
        <a
          *ngFor="let item of adminMenuItems"
          [routerLink]="item.route"
          routerLinkActive="active"
          class="nav-item nav-subitem"
          [title]="item.label"
          (click)="closeMobileSidebar()"
        >
          <i [class]="item.icon"></i>
          <span *ngIf="!isCollapsed">{{ item.label }}</span>
        </a>
      </div>
    </ng-container>

    <!-- Empty state -->
    <div *ngIf="commonMenuItems.length === 0 && !isCollapsed" class="no-menu-items">
      <i class="fas fa-info-circle"></i>
      <p>No menu items available</p>
    </div>

  </nav>

</div>

<!-- Mobile backdrop -->
<div class="sidebar-overlay" [class.active]="isMobileOpen" (click)="closeMobileSidebar()"></div>